import { useGlobals } from '@bwoty-web/ui-kit/hooks';
import logout from '../logout';
import './loggedInBanner.scss';

const LoggedInBanner = () => {
  const { content, user, logoutUrl } = useGlobals();
  return (
    <div className="header-app-logged-in-banner">
      {user?.firstName ? (
        <p>
          {content?.loggedInAs || 'Logged in as'} {user?.firstName}
        </p>
      ) : null}
      <button onClick={() => logout(logoutUrl)} type="button">
        {content.logOut || 'Log out'}
      </button>
    </div>
  );
};

export default LoggedInBanner;
